import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ItemPricingInventoryHealthChipComponent } from './item-pricing-inventory-health-chip.component';

@NgModule({
  declarations: [ItemPricingInventoryHealthChipComponent],
  exports: [ItemPricingInventoryHealthChipComponent],
  imports: [CommonModule],
})
export class ItemPricingInventoryHealthChipModule {}
